import request from "@/utils/request";

// 子任务列表
export function contractDoTaskPageForCheck(data) {
  return request({
    url: "/shop/hg/contractDoTask/platformPage",
    method: "POST",
    data: data,
  });
}

// 子任务列表
export function contractDoTaskPage(data) {
  return request({
    url: "/shop/hg/contractDoTask/page",
    method: "POST",
    data: data,
  });
}

// 子任务详情
export function contractDoTaskDetail(id) {
  return request({
    url: `/shop/hg/contractDoTask/detail/${id}`,
    method: "GET",
  });
}

//审核子任务(单个或多个) 平台审核
export function contractDoTaskPlatformAudit(data) {
  return request({
    url: "/shop/hg/contractDoTask/platformAuditContractDoTask",
    method: "POST",
    data: data,
  });
}
/**
 * 强制通过AI审核（管理员操作）
 *
 * @param {Object} data - {id:""}
 * @returns {Promise} - 返回一个Promise，用于处理请求的响应
 */
export function contractDoTaskForcePassAiForAdmin(data) {
  return request({
    url: "/shop/hg/contractDoTask/forcePassAiForAdmin",
    method: "POST",
    data: data,
  });
}
